import { ResetPasswordModalTranslations } from "./types";

export const enTranslations: ResetPasswordModalTranslations = {
    title: "Reset Password",
    subTitle: "This will send a reset password request to this user. Confirm?",
    confirm: "Confirm",
};
